import Camera from '@/tm/Camera'
import ImageModel2 from '@/tm/ImageModel2';
import AudioModel2 from '@/tm/AudioModel2';
import PoseModel2 from '@/tm/PoseModel2';
import DetectionModel from '@/tm/DetectionModel';
import CustomModelVue from '@/CustomModelVue';
import ModelResult from '@/tm/ModelResult';
import Bar from '@/tm/Bar';

import DropdownMenu from '@/ui/DropdownMenu';
import Box from '@/ui/Box';
import Footer from '@/ui/Footer';
import Menu from '@/ui/Menu'
import SubMenu from '@/ui/SubMenu'
import SvgConnection from '@/ui/SvgConnection'

import * as utils from '@/utils/index.js'
import clickOutside from '@/directives/clickOutside.js';
import mousedownOutside from '@/directives/mousedownOutside.js';

import confirm from '@/global/confirm';
import error from '@/global/logError';
import loading from '@/global/loading';

import CustomTmAudio from './utils/src/CustomTmAudio.js'
import CustomTmImage from './utils/src/CustomTmImage.js'
import CustomTmPose from './utils/src/CustomTmPose.js'
import CustomDetection from './utils/src/CustomDetection.js'
import CustomTestModel from './utils/src/CustomTestModel.js'
import CustomModel from './utils/src/CustomModel.js'
import Audio from '@/tm/Audio/scripts/audio.js';

import { ObjectDetectionTrainer, ObjectDetectionTest, ObjectDetectionTest2, DataLabeler, DataCollector, ObjectDetection } from './object-detection/index.js';

const components = [
    Camera,
    ImageModel2,
    AudioModel2,
    PoseModel2,
    DetectionModel,
    ModelResult,
    Bar,

    DropdownMenu,
    Box,
    Footer,
    Menu,
    SubMenu,
    SvgConnection,

    ObjectDetectionTest,
    ObjectDetectionTest2,
    DataLabeler, 
    DataCollector, 
    ObjectDetection,
    CustomModelVue

    /* Model */
]

const install = (Vue) => {
    if (install.installed) return;

    Object.keys(components).forEach(key => {
        Vue.component(components[key].name, components[key])
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default install
export {
    utils,
    clickOutside,
    mousedownOutside,
    confirm,
    error,
    loading,
    Audio,

    CustomTmPose,
    CustomTestModel,
    CustomTmImage,
    CustomTmAudio,
    CustomModel,
    CustomDetection,

    Camera,
    ImageModel2,
    AudioModel2,
    PoseModel2,
    DetectionModel,
    ModelResult,
    Bar,

    DropdownMenu,
    Box,
    Footer,
    Menu,
    SubMenu,
    SvgConnection,

    ObjectDetectionTrainer,
    ObjectDetectionTest,
    ObjectDetectionTest2,
    DataLabeler, 
    DataCollector,
    ObjectDetection,

    CustomModelVue

    /* Model */
}